<form [formGroup]="form" (submit)="submit()">
  <div class="flex justify-between items-center">
    <h1 mat-dialog-title>{{ "question.selectGroups" | translate }}</h1>
    <div class="mb-5">
      <button mat-icon-button><mat-icon>help_outlined</mat-icon></button>
    </div>
  </div>
  <mat-checkbox
    [checked]="
      (form.value.roles?.length ?? 0) === (data.roleOptions?.length ?? 0)
    "
    (change)="toggleSelectAll($event.checked)"
    >
    <span class="font-bold">{{ "selectAll" | translate }}</span>
  </mat-checkbox>
  @for (role of userRoles; track role) {
    <div>
      <mat-checkbox
        [id]="'selectRoleDialog-' + role"
        [disabled]="form.value.disabledRoles?.includes(role)"
        [checked]="!!form.value.roles?.includes(role)"
        (change)="updateQuestionRoles(role, $event.checked)"
        >
        {{ "roles.plural." + role | translate }}
      </mat-checkbox>
    </div>
  }
  <mat-dialog-actions>
    <button ca-action-button mat-dialog-close>
      {{ "cancel" | translate }}
    </button>
    <button color="primary" ca-action-button>
      {{ "settings.save" | translate }}
    </button>
  </mat-dialog-actions>
</form>
